/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum TrackingSource {
  CarrierTracking = "carrier_tracking",
  CarrierCustomerService = "carrier_customer_service",
  CarrierPortal = "carrier_portal",
  Customer = "customer",
}

export function instanceOfTrackingSource(value: any): boolean {
  for (const key in TrackingSource) {
    if (Object.prototype.hasOwnProperty.call(TrackingSource, key)) {
      if (TrackingSource[key as keyof typeof TrackingSource] === value) {
        return true;
      }
    }
  }
  return false;
}

export function TrackingSourceFromJSON(json: any): TrackingSource {
  return TrackingSourceFromJSONTyped(json, false);
}

export function TrackingSourceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrackingSource {
  return json as TrackingSource;
}

export function TrackingSourceToJSON(value?: TrackingSource | null): any {
  return value as any;
}

export function TrackingSourceToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): TrackingSource {
  return value as TrackingSource;
}
